import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BasePage} from '~/app/pages/base.page';
import {CoreService} from '~/app/core/core.service';
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'home',
    templateUrl: './home.page.html',
    styleUrls: ['./home.page.scss']
})
export class HomePage extends BasePage implements OnInit {
  current_page = 'home';
  backColor = 'white';
  textColor = 'black';

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly core: CoreService,
    private readonly title: Title,
  ) {
    super();
    this.title.setTitle('Home');
  }

  ngOnInit() {
    this.current_page = 'home';
  }

  go_Home() {
    this.current_page = 'home';
    this.backColor = 'white';
    this.textColor = 'black';
  }

  go_Search() {
    this.current_page = 'search';
    this.backColor = '#1F1F26';
    this.textColor = 'white';
  }

  go_Map() {
    this.current_page = 'map';
    this.backColor = '#1F1F26';
    this.textColor = 'white';
  }

  go_Achievements() {
    this.current_page = 'achievements';
    this.backColor = 'white';
    this.textColor = 'black';
  }

  go_Account() {
    this.current_page = 'account';
    this.backColor = '#1F1F26';
    this.textColor = 'white';
  }
}
